"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDialogOpenSelector = void 0;

var _reselect = require("reselect");

var _dialogs = require("./dialogs.reducer");

var sliceSelector = function sliceSelector(state) {
  return state[_dialogs.dialogsReducer.sliceName];
};

var openMapSelector = (0, _reselect.createSelector)(sliceSelector, function (slice) {
  return slice.open;
});

var isDialogOpenSelector = function isDialogOpenSelector(state, dialogName) {
  return !!openMapSelector(state)[dialogName];
};

exports.isDialogOpenSelector = isDialogOpenSelector;